// =====================================
// NO EDITAR ESTE ARCHIVO DIRECTO
// COMPILADO 2026-09-07 13:13:37
// =====================================

enum USERS{
	_ID = 1,		// Usuarios
	VIEW_USERS = 1000,		// Ver usuarios
	EDIT_USERS = 1002,		// Editar usuarios
	EDIT_ACCESS = 1003,		// Editar permisos
	SEARCH_USERS = 1004,		// Buscar usuarios
	REMOVE_USERS = 1900,		// Deshabilitar usuarios
}
enum EVENTS{
	_ID = 2,		// Eventos
	VIEW_EVENTS = 2000,		// Ver eventos
	EDIT_EVENTS = 2001,		// Editar evento
	ASSIGN_USERS_TO_EVENTS = 2002,		// Asignar usuario
	CHANGE_EVENT_STATUS = 2003,		// Asignar estatus
	CLOSE_EVENTS = 2004,		// Cerrar evento
	ASSIGN_EVENT_COORDINATOR = 2005,		// Asignar coordinador
	ASSIGN_EVENT_EXECUTIVE = 2006,		// Asignar ejecutivo comercial
	VIEW_EXPENSE = 2100,		// Ver gastos
	CREATE_EXPENSE = 2101,		// Crear gasto
	APPROVE_EXPENSE = 2102,		// Aprobar gasto
	REJECT_EXPENSE = 2104,		// Rechazar gasto
	DELETE_EXPENSE = 2190,		// Eliminar gasto
	VIEW_BUDGET = 2200,		// Ver Presupuestos
	CREATE_BUDGET = 2201,		// Crear presupuesto
	BUDGET_TO_EXPENSE = 2203,		// Convertir presupuesto a gasto
	DELETE_BUDGET = 2290,		// Eliminar presupuesto
	VIEW_EVENT_WORKERS = 2300,		// Ver trabajadores
	ADD_EVENT_WORKERS = 2301,		// Agregar trabajadores
	EDIT_EVENT_WORKERS = 2302,		// Editar trabajadores
	REMOVE_EVENT_WORKERS = 2303,		// Eliminar trabajadores
	CREATE_EVENT_PAYOUT = 2304,		// Crear liquidación
	CREATE_WORKER_REQUEST = 2305,		// Crear solicitud de trabajadores
	DELETE_WORKER_REQUEST = 2306,		// Eliminar solicitud de trabajadores
	VIEW_EVENT_FORM = 2400,		// Ver formularios
	EDIT_EVENT_FORM = 2401,		// Editar formularios
	REMOVE_EVENT_FORM = 2419,		// Eliminar formularios
	VIEW_COMMENTS = 2500,		// Ver comentarios
	CREATE_COMMENTS = 2501,		// Crear comentarios
	EDIT_COMMENTS = 2502,		// Editar comentarios
	DELETE_COMMENTS = 2503,		// Eliminar comentarios
	VIEW_PROMOTERS = 2600,		// Ver Promotores
	CREATE_PROMOTERS = 2601,		// Crear Promotores
	EDIT_PROMOTERS = 2602,		// Editar Promotores
	DELETE_PROMOTERS = 2690,		// Eliminar Promotores
}
enum ACCOUNTING{
	_ID = 4,		// Contabilidad
	CREATE_REPLACEMENT = 2103,		// Crear reposición de gasto
	VIEW_EXPENSES = 4000,		// Ver gastos
	SET_EXPENSE_PAID = 4001,		// Marcar reposición pagada
	PAY_EXPENSE = 4002,		// Pagar gasto
	REJECT_EXPENSE = 4003,		// Rechazar gasto
	EDIT_EXPENSE_TYPE = 4200,		// Editar tipo de gasto
	EDIT_REJECT_REASON = 4201,		// Editar razones de rechazo
	CREATE_REJECT_REASON = 4202,		// Crear razón de rechazo
	DELETE_REJECT_REASON = 4203,		// Eliminar razón de rechazo
	PAID_PAYOUT = 4300,		// Pagar liquidación
	EDIT_PAYOUT = 4301,		// Editar liquidación
	CANCEL_PAYOUT = 4302,		// Cancelar liquidación
}
enum FORMS{
	_ID = 3,		// Formularios
	VIEW_FORMS = 3000,		// Ver formularios
	CREATE_FORMS = 3001,		// Crear formulario
	EDIT_FORMS = 3002,		// Editar formulario
	DELETE_FORMS = 3090,		// Eliminar formulario
}
enum WORKERS{
	_ID = 5,		// Trabajadores
	VIEW_WORKERS = 5000,		// Ver trabajadores
	CREATE_WORKERS = 5001,		// Crear trabajadores
	EDIT_WORKERS = 5002,		// Editar trabajadores
	VALIDATE_RFC = 5003,		// Validar RFC
	DELETE_WORKERS = 5190,		// Eliminar trabajadores
	BAN_WORKERS = 5200,		// Bannear trabajadores
	UNBAN_WORKERS = 5201,		// Habilitar trabajadores
	VIEW_BAN_REASONS = 5300,		// Ver razones de baneo
	CREATE_BAN_REASON = 5301,		// Crear razón de baneo
	EDIT_BAN_REASON = 5302,		// Editar razón de baneo
	DELETE_BAN_REASON = 5303,		// Eliminar razón de baneo
	VIEW_WORKERS_TITLES = 5904,		// Ver puestos
	CREATE_WORKERS_TITLES = 5905,		// Crear puestos
	EDIT_WORKERS_TITLES = 5906,		// Editar puestos
	DELETE_WORKERS_TITLES = 5990,		// Eliminar puestos
}
enum REPORTS{
	_ID = 6,		// Reportes
	VIEW_REPORTS = 6000,		// Ver reportes
	VIEW_TICKETS_REPORT = 6001,		// Descargar aforos
	VIEW_EXPENSES_REPORT = 6002,		// Descargar reporte de gastos
	VIEW_EVENTS_REPORT = 6003,		// Descargar reporte de eventos
}
enum EMPLOYMENTS{
	_ID = 7,		// Empleos
	VIEW_EMPLOYMENTS = 7000,		// Ver empleos
	CREATE_EMPLOYMENTS = 7001,		// Crear empleos
	EDIT_EMPLOYMENTS = 7002,		// Editar empleos
	DELETE_EMPLOYMENTS = 7090,		// Eliminar empleos
	DELETE_EMPLOYMENTS_RECORDS = 7091,		// Eliminar registros de empleos
	VIEW_PAYMENTS = 7100,		// Ver pagos
	CONFIRM_PAYMENTS = 7101,		// Confirmar pagos
	VIEW_PAYOUTS = 7200,		// Ver nómina
	CREATE_PAYOUT = 7201,		// Generar nómina
	PAY_PAYOUT = 7202,		// Pagar nómina
	CANCEL_PAYOUT = 7203,		// Cancelar nómina
}
enum INVENTORY{
	_ID = 8,		// Inventario
	VIEW_WAREHOUSES = 8000,		// Ver almacenes
	CREATE_WAREHOUSES = 8001,		// Crear almacenes
	EDIT_WAREHOUSES = 8002,		// Editar almacenes
	DELETE_WAREHOUSES = 8090,		// Eliminar almacenes
	VIEW_INVENTORY = 8100,		// Ver inventario
	CREATE_INVENTORY = 8101,		// Crear inventario
	MOVE_INVENTORY = 8102,		// Mover inventario
	DELETE_INVENTORY = 8190,		// Eliminar inventario
	VIEW_INVENTORY_SHIPMENTS = 8200,		// Ver envíos
	CREATE_INVENTORY_SHIPMENTS = 8201,		// Crear envíos
	EDIT_INVENTORY_SHIPMENTS = 8202,		// Editar envíos
	EDIT_INVENTORY_SHIPMENTS_RETURN_DATE = 8203,		// Editar fecha de retorno de envíos
	EDIT_INVENTORY_SHIPMENTS_USER_COORDINATOR = 8204,		// Editar coordinador de envíos
	DELETE_INVENTORY_SHIPMENTS = 8290,		// Eliminar envíos
	VIEW_INVENTORY_REQUESTS = 8300,		// Ver solicitudes de inventario
	CREATE_INVENTORY_REQUESTS = 8301,		// Crear solicitudes de inventario
	EDIT_INVENTORY_REQUESTS = 8302,		// Editar solicitudes de inventario
	APPROVE_INVENTORY_REQUESTS = 8303,		// Aprobar solicitudes de inventario
	REJECT_INVENTORY_REQUESTS = 8304,		// Rechazar solicitudes de inventario
	DELETE_INVENTORY_REQUESTS = 8390,		// Eliminar solicitudes de inventario
}
enum CONTRACTS{
	_ID = 9,		// Contratos
	VIEW_CONTRACTS = 9000,		// Ver contratos
	EDIT_CONTRACTS = 9001,		// Editar contratos
}
enum ISSUES{
	_ID = 10,		// Tickets
	VIEW_ISSUES = 10000,		// Ver tickets
	CREATE_ISSUES = 10001,		// Crear tickets
	EDIT_ISSUES = 10002,		// Editar tickets
	DELETE_ISSUES = 10090,		// Eliminar tickets
	VIEW_ISSUE_TYPES = 10100,		// Ver tipos de tickets
	CREATE_ISSUE_TYPES = 10101,		// Crear tipos de tickets
	EDIT_ISSUE_TYPES = 10102,		// Editar tipos de tickets
	DELETE_ISSUE_TYPES = 10190,		// Eliminar tipos de tickets
}
const ACCESS_ARRAY = [
	{
		id: 1,
		varname: 'USERS',
		name: 'Usuarios',
		access: [
			{ id: 1000, name: 'Ver usuarios' },
			{ id: 1002, name: 'Editar usuarios' },
			{ id: 1003, name: 'Editar permisos' },
			{ id: 1004, name: 'Buscar usuarios' },
			{ id: 1900, name: 'Deshabilitar usuarios' },
		],
	},
	{
		id: 2,
		varname: 'EVENTS',
		name: 'Eventos',
		access: [
			{ id: 2000, name: 'Ver eventos' },
			{ id: 2001, name: 'Editar evento' },
			{ id: 2002, name: 'Asignar usuario' },
			{ id: 2003, name: 'Asignar estatus' },
			{ id: 2004, name: 'Cerrar evento' },
			{ id: 2005, name: 'Asignar coordinador' },
			{ id: 2006, name: 'Asignar ejecutivo comercial' },
			{ id: 2100, name: 'Ver gastos' },
			{ id: 2101, name: 'Crear gasto' },
			{ id: 2102, name: 'Aprobar gasto' },
			{ id: 2104, name: 'Rechazar gasto' },
			{ id: 2190, name: 'Eliminar gasto' },
			{ id: 2200, name: 'Ver Presupuestos' },
			{ id: 2201, name: 'Crear presupuesto' },
			{ id: 2203, name: 'Convertir presupuesto a gasto' },
			{ id: 2290, name: 'Eliminar presupuesto' },
			{ id: 2300, name: 'Ver trabajadores' },
			{ id: 2301, name: 'Agregar trabajadores' },
			{ id: 2302, name: 'Editar trabajadores' },
			{ id: 2303, name: 'Eliminar trabajadores' },
			{ id: 2304, name: 'Crear liquidación' },
			{ id: 2305, name: 'Crear solicitud de trabajadores' },
			{ id: 2306, name: 'Eliminar solicitud de trabajadores' },
			{ id: 2400, name: 'Ver formularios' },
			{ id: 2401, name: 'Editar formularios' },
			{ id: 2419, name: 'Eliminar formularios' },
			{ id: 2500, name: 'Ver comentarios' },
			{ id: 2501, name: 'Crear comentarios' },
			{ id: 2502, name: 'Editar comentarios' },
			{ id: 2503, name: 'Eliminar comentarios' },
			{ id: 2600, name: 'Ver Promotores' },
			{ id: 2601, name: 'Crear Promotores' },
			{ id: 2602, name: 'Editar Promotores' },
			{ id: 2690, name: 'Eliminar Promotores' },
		],
	},
	{
		id: 4,
		varname: 'ACCOUNTING',
		name: 'Contabilidad',
		access: [
			{ id: 2103, name: 'Crear reposición de gasto' },
			{ id: 4000, name: 'Ver gastos' },
			{ id: 4001, name: 'Marcar reposición pagada' },
			{ id: 4002, name: 'Pagar gasto' },
			{ id: 4003, name: 'Rechazar gasto' },
			{ id: 4200, name: 'Editar tipo de gasto' },
			{ id: 4201, name: 'Editar razones de rechazo' },
			{ id: 4202, name: 'Crear razón de rechazo' },
			{ id: 4203, name: 'Eliminar razón de rechazo' },
			{ id: 4300, name: 'Pagar liquidación' },
			{ id: 4301, name: 'Editar liquidación' },
			{ id: 4302, name: 'Cancelar liquidación' },
		],
	},
	{
		id: 3,
		varname: 'FORMS',
		name: 'Formularios',
		access: [
			{ id: 3000, name: 'Ver formularios' },
			{ id: 3001, name: 'Crear formulario' },
			{ id: 3002, name: 'Editar formulario' },
			{ id: 3090, name: 'Eliminar formulario' },
		],
	},
	{
		id: 5,
		varname: 'WORKERS',
		name: 'Trabajadores',
		access: [
			{ id: 5000, name: 'Ver trabajadores' },
			{ id: 5001, name: 'Crear trabajadores' },
			{ id: 5002, name: 'Editar trabajadores' },
			{ id: 5003, name: 'Validar RFC' },
			{ id: 5190, name: 'Eliminar trabajadores' },
			{ id: 5200, name: 'Bannear trabajadores' },
			{ id: 5201, name: 'Habilitar trabajadores' },
			{ id: 5300, name: 'Ver razones de baneo' },
			{ id: 5301, name: 'Crear razón de baneo' },
			{ id: 5302, name: 'Editar razón de baneo' },
			{ id: 5303, name: 'Eliminar razón de baneo' },
			{ id: 5904, name: 'Ver puestos' },
			{ id: 5905, name: 'Crear puestos' },
			{ id: 5906, name: 'Editar puestos' },
			{ id: 5990, name: 'Eliminar puestos' },
		],
	},
	{
		id: 6,
		varname: 'REPORTS',
		name: 'Reportes',
		access: [
			{ id: 6000, name: 'Ver reportes' },
			{ id: 6001, name: 'Descargar aforos' },
			{ id: 6002, name: 'Descargar reporte de gastos' },
			{ id: 6003, name: 'Descargar reporte de eventos' },
		],
	},
	{
		id: 7,
		varname: 'EMPLOYMENTS',
		name: 'Empleos',
		access: [
			{ id: 7000, name: 'Ver empleos' },
			{ id: 7001, name: 'Crear empleos' },
			{ id: 7002, name: 'Editar empleos' },
			{ id: 7090, name: 'Eliminar empleos' },
			{ id: 7091, name: 'Eliminar registros de empleos' },
			{ id: 7100, name: 'Ver pagos' },
			{ id: 7101, name: 'Confirmar pagos' },
			{ id: 7200, name: 'Ver nómina' },
			{ id: 7201, name: 'Generar nómina' },
			{ id: 7202, name: 'Pagar nómina' },
			{ id: 7203, name: 'Cancelar nómina' },
		],
	},
	{
		id: 8,
		varname: 'INVENTORY',
		name: 'Inventario',
		access: [
			{ id: 8000, name: 'Ver almacenes' },
			{ id: 8001, name: 'Crear almacenes' },
			{ id: 8002, name: 'Editar almacenes' },
			{ id: 8090, name: 'Eliminar almacenes' },
			{ id: 8100, name: 'Ver inventario' },
			{ id: 8101, name: 'Crear inventario' },
			{ id: 8102, name: 'Mover inventario' },
			{ id: 8190, name: 'Eliminar inventario' },
			{ id: 8200, name: 'Ver envíos' },
			{ id: 8201, name: 'Crear envíos' },
			{ id: 8202, name: 'Editar envíos' },
			{ id: 8203, name: 'Editar fecha de retorno de envíos' },
			{ id: 8204, name: 'Editar coordinador de envíos' },
			{ id: 8290, name: 'Eliminar envíos' },
			{ id: 8300, name: 'Ver solicitudes de inventario' },
			{ id: 8301, name: 'Crear solicitudes de inventario' },
			{ id: 8302, name: 'Editar solicitudes de inventario' },
			{ id: 8303, name: 'Aprobar solicitudes de inventario' },
			{ id: 8304, name: 'Rechazar solicitudes de inventario' },
			{ id: 8390, name: 'Eliminar solicitudes de inventario' },
		],
	},
	{
		id: 9,
		varname: 'CONTRACTS',
		name: 'Contratos',
		access: [
			{ id: 9000, name: 'Ver contratos' },
			{ id: 9001, name: 'Editar contratos' },
		],
	},
	{
		id: 10,
		varname: 'ISSUES',
		name: 'Tickets',
		access: [
			{ id: 10000, name: 'Ver tickets' },
			{ id: 10001, name: 'Crear tickets' },
			{ id: 10002, name: 'Editar tickets' },
			{ id: 10090, name: 'Eliminar tickets' },
			{ id: 10100, name: 'Ver tipos de tickets' },
			{ id: 10101, name: 'Crear tipos de tickets' },
			{ id: 10102, name: 'Editar tipos de tickets' },
			{ id: 10190, name: 'Eliminar tipos de tickets' },
		],
	},
]

export default {
	ACCESS_ARRAY,
	USERS,
	EVENTS,
	ACCOUNTING,
	FORMS,
	WORKERS,
	REPORTS,
	EMPLOYMENTS,
	INVENTORY,
	CONTRACTS,
	ISSUES,
}